import TourTooltip from 'elements/tooltip/TourTooltip'
import { TourConfigType } from 'persistentContent/tours/types'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const StepTooltip: FC = (props) => {
  const translate = useTranslate()
  return (
    <TourTooltip
      title={translate('Quick Suggestions')}
      subtext={translate(
        'Ada provides contextual suggestions based on where you are in the app. Click any suggestion to get started quickly.'
      )}
      {...props}
    />
  )
}

const ChatSuggestions: TourConfigType = {
  spotlights: [{ targetId: 'Ada-Chat-Suggestions', autoScroll: true }],
  tooltips: [
    {
      targetId: 'Ada-Chat-Suggestions',
      placement: 'top',
      component: StepTooltip,
      options: { style: { marginBottom: 10 } },
    },
  ],
}

export default ChatSuggestions

